import BackArrow from '#/assets/images/icons/arrow-back.svg'
import SvgTopHap from '#/assets/images/logos/logo-hexa.svg'
import Link, { LinkProps } from '#/components/Link'
import { useBreadcrumbs } from '#/hooks/useBreadcrumbs'
import { logEvent } from '#/services/analytics'

type Props = {
  property: TopHap.Property
  linkEnabled?: boolean
  backToFavorites?: boolean
}

const Item: React.FC<LinkProps> = ({
  children,
  linkEnabled = true,
  ...props
}) =>
  (linkEnabled ? (
    <Link
      className='inline-block whitespace-nowrap rounded-full bg-white px-3 py-0.5 text-xs capitalize shadow'
      {...props}
    >
      {children}
      {' '}
      &gt;
    </Link>
  ) : (
    <div className='inline-block whitespace-nowrap rounded-full bg-white px-3 py-0.5 text-xs capitalize shadow'>
      {children}
      {' '}
      &gt;
    </div>
  ))

const HomeBreadCrumb: React.FC<{ linkEnabled: boolean }> = ({ linkEnabled = true }) =>
  (linkEnabled ? (
    <Link className='m-auto inline-block pr-2' href='/'>
      <SvgTopHap className='h-full w-4' />
    </Link>
  ) : (
    <div className='m-auto inline-block pr-2'>
      <SvgTopHap className='h-full w-4' />
    </div>
  ))

const Breadcrumb: React.FC<Props> = ({ property, linkEnabled = true, backToFavorites = false }) => {
  const { zones, zoneLink } = useBreadcrumbs(property.zones)

  function logClick(region: string, region_name: string) {
    logEvent('select_content', {
      content_type: 'property_detail',
      item_id: 'breadcrumb',
      value: region,
      region_name,
      property_id: property.id,
      address: property.address.FullAddress
    })
  }

  return (
    <nav className='no-scrollbar space-x-2 overflow-auto whitespace-nowrap p-4'>
      {backToFavorites && (
        <div className='m-auto inline-block pr-2'>
          <Link
            className='truncate pl-2 align-middle text-xs font-medium text-primary xs:w-full sm:w-full'
            href='/app/workspaces/favorites'
          >
            <BackArrow className='h-3 w-4 shrink-0 text-primary' />
            Back
          </Link>
        </div>
      )}
      <HomeBreadCrumb linkEnabled={linkEnabled} />
      {
        zones?.map(zone => (
          <Item
            key={zone.id}
            href={zoneLink(zone.id, true)}
            linkEnabled={linkEnabled}
            onClick={() => logClick(zone.type, zone.name)}
          >
            {zone.name}
          </Item>
        ))
      }
      <Item
        href={zoneLink(property.id, true)}
        linkEnabled={linkEnabled}
        onClick={() => logClick('address', property.displayAddress)}
      >
        {property.displayAddress}
      </Item>
    </nav>
  )
}

export default Breadcrumb
